module.exports = __webpack_public_path__ + "img/Foodrazor-logo.04b7e541.svg";